import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { assessmentStatus } from "@/utils/constants";


export default /*#__PURE__*/_defineComponent({
  __name: 'assessmentStatus',
  props: {
  state: {
    type: String,
    default: assessmentStatus.complete,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(`tw-bg-[#FFFFFF] tw-flex tw-justify-center tw-items-center tw-gap-[5px] tw-rounded-[4px] tw-px-[5px] tw-py-[3px] tw-text-[11px] tw-not-italic tw-font-[500] tw-leading-[130%] ${__props.state
      .replaceAll(' ', '')
      .toLowerCase()}`)
  }, _toDisplayString(__props.state), 3))
}
}

})